<template>
    <div class="client-journal-table">
        <div class="alert alert-warning text-center font-bold" v-if="loading">
            <i class="fa-regular fa-spinner fa-spin-pulse m-r-xs"></i>
            {{ t_loading }}
        </div>

        <table class="table table-striped table-bordered dataTable dtr-inline" aria-label="client journal table">
            <thead>
                <tr>
                    <th
                        @click.stop.prevent="sort(id)" v-for="(header, id) in table_head"
                        :class="[sort_column === id ? sort_direction : '', `cursor-pointer`]"
                    >
                        {{ header }}
                        <span v-if="sort_column === id && sort_direction === 'asc'" class="sort-asc"></span>
                        <span v-else-if="sort_column === id && sort_direction  === 'desc'" class="sort-desc"></span>
                        <span v-else class="sort-alt"></span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in table_data">
                    <td v-for="(header, id) in table_head" v-html="row[id] || '-'"></td>
                </tr>
            </tbody>
        </table>
        <div class="row cs-row text-center text-danger" v-if="table_data.length === 0 && loading === false">
            <h2 class="no-margins p-sm">{{ t_no_result_data }}</h2>
        </div>
        <div class="text-center">
            <client-journal-pagination
                    :page="page"
                    :pages="pages"
                    event="updateClientJournal">
            </client-journal-pagination>
        </div>
    </div>
</template>
<script>
    import toaster from "../common/toaster";

    export default {
        components: {
            clientJournalPagination: require('./client-detail/pagination.vue').default,
        },
        data() {
            return {
                t_load_error: Lang.langGet("Failed to load table."),
                t_no_result_data: Lang.langGet("No results with current filter."),
                t_loading: Lang.langGet("The data is currently loading. This may take a while depending on the current filter."),
                table_head: {
                    'date': Lang.langGet("Date"),
                    'client_mms_id': Lang.langGet("Client Name"),
                    'category': Lang.langGet("Category"),
                    'typ': Lang.langGet("Type"),
                    'msg': Lang.langGet("Message")
                },
                table_size: {
                    'date': 1,
                    'client_mms_id': 2,
                    'category': 1,
                    'typ': 1,
                    'msg': 7
                },
                table_data: [],
                loading: false,
                sort_column: 'date',
                sort_direction: 'desc',
                filter_id: -1,
                limit: 10,
                page: 0,
                pages: 0
            }
        },
        methods: {
            load: function () {
                this.loading = true;
                EaseEventBus.fire('updateJournalCount', {
                    filtered: 0,
                    total: 0
                });

                axios.post('/system/client-journal/table', {
                    project_id: Laravel.activeProject,
                    filter_id: this.filter_id,
                    sort_column: this.sort_column,
                    sort_direction: this.sort_direction,
                    limit: this.limit,
                    page: this.page
                }).then((response) => {
                    this.table_data = response.data.data.data;
                    this.loading = false;
                    this.pages = response.data.data.pages;

                    EaseEventBus.fire('updateJournalCount', {
                        filtered: response.data.data.filtered,
                        total: response.data.data.total
                    });
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_load_error);
                    this.loading = false;
                });
            },
            sort: function (column) {
                if (this.sort_column === column) {
                    if (this.sort_direction === 'asc') {
                        this.sort_direction = 'desc';
                    } else {
                        this.sort_direction = 'asc';
                    }
                } else {
                    this.sort_column = column;
                    this.sort_direction = 'asc';
                }

                this.page = 0;
                this.load();
            },
            reset: function () {
                _.extend(this.$data, this.$options.data());
            }
        },
        mounted() {
            EaseEventBus.listen('updateTable', (data) => {
                this.page = 0;

                if (data == null) {
                    this.reset();
                } else {
                    this.filter_id = data.filter;
                    this.load();
                }
            });

            EaseEventBus.listen('updateClientJournal', (page) => {
                this.page = page;
                this.load();
            });
        }
    }
</script>
<style scoped>
    .sort-asc:after {
        font-family: "Font Awesome 6 Pro" !important;
        content: '\f161' !important;
        opacity: 0.6 !important;
    }

    .sort-desc:after {
        font-family: "Font Awesome 6 Pro" !important;
        content: '\f160' !important;
        opacity: 0.6 !important;
    }

    .sort-alt:after {
        font-family: "Font Awesome 6 Pro" !important;
        content: '\e099' !important;
        opacity: 0.125 !important;
    }

    .table {
        thead {
            height: 50px;

            tr th {
                vertical-align: middle !important;
            }
        }

        tbody tr {
            height: 50px;

        }
    }
</style>
